module.exports = __webpack_public_path__ + "static/media/Cloyster_gaussian2.938277b0.png";